// Default / fallback flags.
// These are used before the remote fetch resolves, and as a safety net
// if the remote fetch fails.
export const defaultFlags = {
  newCheckout: false,
  darkMode: true,
  betaDashboard: false,
};